/*
 * Urgency per Product banner (EMKT-663)
 *
 * Renders a live countdown inside an urgency promo banner. The light-DOM markup
 * (label + timer line) is rendered server-side by snippets/urgency-banner.liquid;
 * this element manages the countdown digits and visibility. When the timer ends,
 * only the timer line (`[data-urgency-timer]`) is removed; the label
 * (`[data-urgency-text]`) persists. If nothing remains, the banner is removed.
 *
 * Relies on the global `CustomElement` base class and `getTimeParts` helper
 * defined in core.js (loaded synchronously in <head> via app-essentials).
 */
class UrgencyBanner extends CustomElement {
  props = {
    targetDate: '',
  }

  constructor() {
    super()
  }

  get refs() {
    return {
      countdown: this.$el.find('[data-urgency-countdown]'),
      timer: this.$el.find('[data-urgency-timer]'),
      text: this.$el.find('[data-urgency-text]'),
    }
  }

  mounted() {
    super.mounted()

    const { targetDate } = this.props

    // Text-only banner (no timer): reveal it and keep it visible.
    if (!targetDate) {
      this.$el.removeClass('hidden')
      return
    }

    const endTime = new Date(targetDate.replace(' ', 'T'))
    let delta = isNaN(endTime.getTime()) ? -1 : (endTime.getTime() - Date.now()) / 1000

    // Timer already finished/invalid: drop the timer part (keeping any label).
    if (delta <= 0) {
      this.expireTimer()
      return
    }

    this.tick(delta)
    this.$el.removeClass('hidden')

    this.interval = setInterval(() => {
      delta -= 1
      this.tick(delta)
    }, 1000)
  }

  tick(delta) {
    if (delta <= 0) {
      this.expireTimer()
      return
    }

    const [days, hours, minutes, seconds] = getTimeParts(delta)

    this.refs.countdown.text(`${days}d ${hours}h ${minutes}m ${seconds}s`)
  }

  // When the timer ends remove the whole banner.
  expireTimer() {
    clearInterval(this.interval)
    this.refs.timer.remove()

    // if (this.refs.text.length) {
      this.$el.addClass('hidden')
    // } else {
    //   this.dismiss()
    // }
  }

  // Remove the whole section wrapper (not just the bar) so the buy box drops its
  // squared-off top corners and renders as a normal rounded card.
  dismiss() {
    clearInterval(this.interval)
    const wrapper = this.closest(".product-urgency-banner-section")
    ;(wrapper || this).remove()
  }

  onDestroy() {
    clearInterval(this.interval)
  }
}

if (!customElements.get('urgency-banner')) {
  customElements.define('urgency-banner', UrgencyBanner)
}
